import { render, staticRenderFns } from "./NotificationDialog.vue?vue&type=template&id=9a2c742a&scoped=true"
import script from "./NotificationDialog.vue?vue&type=script&lang=js"
export * from "./NotificationDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationDialog.vue?vue&type=style&index=0&id=9a2c742a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2c742a",
  null
  
)

export default component.exports